module.exports = __webpack_public_path__ + "img/msm.412b56da.png";